import {PolicyIssuanceModule} from './PolicyIssuance'


export const ListOfFunctionalModules = [
    PolicyIssuanceModule
];
